export enum DOCUMENT_TYPE_FILTER {
  BANK_STATEMENT = "BANK_STATEMENT",
}

export const DOCUMENT_TYPE_FILTER_LABEL: Record<DOCUMENT_TYPE_FILTER, string> =
  {
    [DOCUMENT_TYPE_FILTER.BANK_STATEMENT]: "Bank Statement",
  };

export const DOCUMENT_ANALYSIS_FILENAME_PREFIX = "test-document-analysis";
